import type { IncidentGroup } from '../services/incidentsApi';

export type IncidentGroupActionTarget = {
  groupKey: string;
  policyId?: string;
};

/**
 * Use the API-provided group_key for action requests; include policy_id when known.
 */
export function resolveIncidentGroupActionTarget(group: IncidentGroup): IncidentGroupActionTarget {
  const groupKey = String(group.group_key || '').trim();
  if (!groupKey) {
    const incidentType = String(group.incident_type || 'unknown').trim();
    const zoneId = String(group.zone_id || '-').trim();
    const cameraId = String(group.camera_id || '-').trim();
    const deviceId = String(group.device_id || '-').trim();
    const policyId = String(group.policy_id || '').trim();
    if (policyId) {
      return {
        groupKey: `${policyId}|${incidentType}|${zoneId}|${cameraId}|${deviceId}`,
        policyId,
      };
    }
    return {
      groupKey: `${incidentType}|${zoneId}|${cameraId}|${deviceId}`,
    };
  }
  const policyId = String(group.policy_id || '').trim() || undefined;
  return { groupKey, policyId };
}
